import { Dialog as OriUIDialog } from '@ori-ui/components';
import { Box, Typography } from '@ori-ui/mui';

import type { DialogProps } from './types';

export const Dialog = ({ children, header, hideCloseButton, onClose, open }: DialogProps) => (
  <OriUIDialog
    hideCloseButton={hideCloseButton}
    open={open}
    size="small"
    onClose={onClose}
  >
    <Box
      alignItems="center"
      display="flex"
      flexDirection="column"
      height="100%"
      justifyContent="center"
      textAlign="center"
      width="100%"
    >
      <Typography
        fontSize={22}
        fontWeight="bold"
        pb={8}
        pt={10}
        px={10}
        variant="subtitle1"
      >
        {header}
      </Typography>
      <Box pb={8}>{children}</Box>
    </Box>
  </OriUIDialog>
);
